import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Dashboard from '../pages/inspector/Dashboard';

import Resolve from '../pages/inspector/resolved';
import NotResolved from '../pages/inspector/NotResolved';
import Assigned from '../pages/inspector/assigned';
import Assignedai from '../pages/inspector/assignedai';
import Inspection from '../pages/inspector/Inspection';
import AddProperty from '../pages/inspector/addProperty';
import AddPropertyai from '../pages/inspector/addPropertyai';
import Comment from '../pages/inspector/commented';
import Comment2 from '../pages/inspector/commented2';
import Reassessment from '../pages/inspector/reassessment';
import ReassessmentS1D from '../pages/inspector/reassessmentS1D';
import Reviewed from '../pages/inspector/reviewed';
import ReviewedS1D from '../pages/inspector/reviewedS1D';
import Commented from '../pages/inspector/commentedwithoutpic';
import Added from '../pages/inspector/Added';
import FlaggedByAlgorithm from '../pages/inspector/flaggedbyalgorithm';
import ReassessmentFormPage from '../pages/inspector/ReassessmentFormPage';
import DoNotReassessmentFormPage from '../pages/inspector/DoNotReassessmentFormPage';

const InspectorRoutes = () => (
  <Routes>
    <Route path="/" element={<Dashboard />} />
    <Route path="/inspection" element={< Inspection/>} />
    <Route path="/resolved" element={ <Resolve />} />
    <Route path="/not-resolved" element={ <NotResolved />} />
    <Route path="/assigned" element={<Assigned />} />
    <Route path="/assignedai" element={<Assignedai />} />
    <Route path="/pending-review" element={<Assignedai />} />
    <Route path="/addProperty" element={<AddProperty/>} />
    <Route path="/addPropertyai" element={<AddPropertyai/>} />
    <Route path="/comment" element={<Comment/>} />
    <Route path="/commented" element={<Commented/>} />
    <Route path="/comments" element={<Comment2/>} />
    <Route path="/reassessment" element={<Reassessment />} />
    <Route path="/reassessment-s1d" element={<ReassessmentS1D />} />
    <Route path="/reviewed" element={<Reviewed />} />
    <Route path="/reviewed-s1d" element={<ReviewedS1D />} />
    <Route path="/addedbyme" element={<Added />} />
    
    <Route path="/flaggedbyalgorithm" element={<FlaggedByAlgorithm />} />
    <Route path="/reassess/:pin" element={<ReassessmentFormPage />} />
    <Route path="/do-not-reassess/:pin" element={<DoNotReassessmentFormPage />} />
    
    <Route path="*" element={<div>404 Not Found</div>} />
  </Routes>
);

export default InspectorRoutes;